module.exports = __webpack_public_path__ + "static/sonia_hero-ea0761d3bd6863ad890824a0e52e8531.png";